import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/exercise/ExerciseContent.tsx");
